module.exports = "/_next/static/images/validating-local-327dc94ba0d661e0964acdb332437970.gif";